import React from 'react';
import { MantenedoresProvider } from './MantenedoresContext';
import { useSelector } from 'react-redux';

const MantenedoresRouteWrapper = ({ Component, ...props }) => {
  const { user } = useSelector(state => state.auth);
  return (
    <MantenedoresProvider user={user}>
      <Component {...props} />
    </MantenedoresProvider>
  );
};

export default MantenedoresRouteWrapper;
